export function getErrorMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    return JSON.stringify(error);
  } catch (stringifyError) {
    console.error('Unable to stringify error', stringifyError);
    return 'An unexpected error occurred.';
  }
}
